import React, { useState } from 'react';
import Modal from "../molecules/Modal"

const FormModalButton = props => {
    const [ show, setShow ] = useState(false)
    const [ value, setValue ] = useState('')
    let formContent;
    if (props.type === 'options') {
        if (!props.options || props.options.length === 0 ) { 
            formContent = (<div>Tidak ada opsi</div>)
        } else {
            formContent = (
                <div className="form-group">
                     <select
                          className="form-control"
                          onChange={e => setValue(e.target.value)}
                          value={value.value}
                      >
                        {
                          props.options.map((i,idx) => (
                              <option
                                  key={idx}
                                  value={JSON.stringify(i.values)}
                                  className={`${idx === 0 ? "selected":""}`}
                              >
                                {i.name}
                              </option>
                          ))
                        }
                      </select>
                </div>
               )  
        }
        
    } else {
       formContent = (
        <div className="form-group">
            <input
                onChange={e => setValue(e.target.value)}
                placeholder={props.buttonText}
                className="form-control"
                value={value}
            />
        </div>
       ) 
    }
    return (
        <div>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                title={props.buttonText}
                size={"md"}
                bodyClassName="py-4 text-center"
                type="oneButton"
                bClick={() => props.onButtonClick(value)}
                bText={"Simpan"}
                buttons
            >
                {formContent}
            </Modal>

            <button
                type="button"
                style={props.style}
                className={`${props.className || 'badge btn btn-sm btn-primary' }`}
                onClick={() => setShow(true)}
                >
                {props.buttonText}
            </button>
        </div>
  )
};

export default FormModalButton;
